<ng-container *ngIf="currentSettings">
  <div class="c-table__main-container" #mainContainer [class.widget]="currentSettings?.type === 'widget'">
    <div class="c-table__table-container">
      <gtd-table-header [facade]="this" [displayFilters]="displayFilters" [filtersModel]="filtersModel"> </gtd-table-header>

      <ng-container *ngIf="currentSettings?.searchKey">
        <div class="c-table__content-search">
          <input
            type="text"
            i18n-placeholder="@@common.search"
            placeholder="Search"
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearchChange($event)"
          />
          <p500-ui-icon name="search c-form-field__icon"></p500-ui-icon>
        </div>
      </ng-container>

      <ng-container [ngSwitch]="true">
        <gtd-table
          *ngSwitchCase="currentSettings?.type === 'table' || currentSettings?.type === 'widget'"
          #table
          [key]="key"
          [data]="data"
          [columns]="visibleColumns"
          [orderValues]="tableParams?.orderValues || {}"
          [checkboxesGroup]="this.currentSettings?.checkboxesConfig?.formGroup"
          [statusHint]="currentSettings?.statusHint"
          [rowActions]="currentSettings?.rowActions"
          [statusColorScheme]="currentSettings?.statusColorScheme || {}"
          (sort)="sort($event)"
          [isLoading]="isLoading"
          [stickyActions]="currentSettings?.stickyActions"
          [disabledSortColumns]="currentSettings?.disabledSortColumns"
          class="c-table__table-body"
        ></gtd-table>

        <ng-container *ngSwitchCase="currentSettings?.type === 'card'">
          <div
            class="c-card__layout"
            [ngClass]="currentSettings?.layoutCustomClass ? 'c-card__layout--' + currentSettings?.layoutCustomClass : ''"
          >
            <ng-container *ngFor="let row of data?.rows">
              <ng-container
                *ngIf="currentSettings?.cardComponent as cardComponent"
                p500UIComponentOutlet
                [component]="cardComponent"
                [settings]="{ row: row, actions: currentSettings?.rowActions }"
              ></ng-container>
            </ng-container>
          </div>

          <ng-container *ngIf="!data">
            <p500-ui-cube-preloader></p500-ui-cube-preloader>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="data && !data?.rows?.length">
        <gtd-empty
          class="c-table__empty-block"
          [desc]="currentSettings?.emptyTemplateAction ? dataNotFoundWithAction : dataNotFound"
          icon="box"
          [actions]="[createActionButton]"
        ></gtd-empty>
      </ng-container>
    </div>
    <p500-ui-pagination
      *ngIf="pagination"
      class="c-table__pagination"
      [class.widget]="currentSettings?.type === 'widget'"
      [infinityLimit]="500"
      [totalItems]="pagination.total"
      [itemsPerPage]="pagination.limit"
      [currentPage]="pagination.page"
      (currentPageChange)="changePage($event)"
      (limitChange)="changeLimit($event)"
    >
    </p500-ui-pagination>
  </div>

  <ng-template #createActionButton>
    <ng-container *ngIf="currentSettings?.emptyTemplateAction as emptyTemplateAction">
      <ng-container p500UIComponentOutlet [component]="emptyTemplateAction.component" [settings]="emptyTemplateAction.props"></ng-container>
    </ng-container>
  </ng-template>
</ng-container>
